module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/mv_maedori_03-b54bcbb542dd9de288a748a35a538c36.webp";